<div #vectorGraphic></div>
<div
  #nextGraphic
  class="invisible"></div>
